import { getUser } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getUser";
import { fetchResults } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/__internal__/fetchResults/fetchResults";
import { useCategoryPageRequestParamsContext } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/CategoryPageRequestParamsProvider";
import { useStrictLocalization } from "@faire/web/common/localization";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

export const useCategoryPageQuery = () => {
  const { strictLocalize } = useStrictLocalization();
  const user = getUser();

  const { queryKey, fetchResultsOptions } =
    useCategoryPageRequestParamsContext();

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey,
    queryFn: ({ signal }) =>
      fetchResults(fetchResultsOptions, user, { signal }, strictLocalize),
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });
};
